import { render, staticRenderFns } from "./UkLandRegistryTransfer.vue?vue&type=template&id=b51d8dce&scoped=true&"
import script from "./UkLandRegistryTransfer.vue?vue&type=script&lang=js&"
export * from "./UkLandRegistryTransfer.vue?vue&type=script&lang=js&"
import style0 from "./UkLandRegistryTransfer.vue?vue&type=style&index=0&id=b51d8dce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51d8dce",
  null
  
)

export default component.exports